import React from "react";

const pageStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
    width: "100%",
};

const textStyle = {
    fontSize: "2rem",
    color: "#333",
};

export default function CustomErrorPage() {
    return (
        <div style={pageStyle}>
            <div>
                <h1 style={textStyle}>Oops! Something went wrong.</h1>
                <p>Please try again or contact support at me-support@satisfilabs.com.</p>
            </div>
        </div>
    );
}
